const APP_VERSION = '1772821544625';
export default APP_VERSION;
